import { baseAPIRequest } from 'utilities/http';

import { baseURI } from './config';

async function getQuestionDetails (questionId) {

	try {

		const url = `${baseURI}/questions/${questionId}`;
		const response = await baseAPIRequest({
			url,
			params: {
				method: 'GET'
			}
		});

		if (!response.isSuccess) {

			const [ error ] = response.errors;
			throw new Error(`Failed to get details for question ID "${questionId}": ${error.message}`);

		}

		return response.result;

	} catch (error) {

		// eslint-disable-next-line no-console
		console.error(error.message);
		throw Error;

	}

}

export default getQuestionDetails;
